import React, { useContext } from 'react';
import { WidthContext } from '../../WidthContext';
import './panelistInfo.scss';

const PanelistInfo = ({ data, origin }) => {
  const { panelist, title, year, years, copy, c } = data;
  const { touch } = useContext(WidthContext);
  return (
    <div className={`panelistInfo panelistInfo--${origin}`}>
      {touch && origin === 'quotes' ? (
        <div className="panelistInfo__close">
          <svg
            width="43"
            height="43"
            viewBox="0 0 43 43"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="21.9199" cy="21.2583" r="20.5" stroke="#1B365D" />
            <path
              d="M15.9199 16.3755L17.0371 15.2583L21.9056 20.1268L26.8027 15.2583L27.9199 16.3755L23.0514 21.244L27.9199 26.1411L26.8027 27.2583L21.9056 22.3898L17.0371 27.2583L15.9199 26.1411L20.7884 21.244L15.9199 16.3755Z"
              fill="#1B365D"
            />
            <path
              d="M21.9761 20.1977L26.8025 15.3995L27.7785 16.3755L22.9807 21.1733L22.9102 21.2438L22.9805 21.3145L27.7787 26.1409L26.8025 27.1171L21.9761 22.3189L21.9054 22.2486L21.8349 22.3191L17.0371 27.1169L16.0611 26.1409L20.8593 21.3145L20.9296 21.2438L20.8591 21.1733L16.0613 16.3755L17.0371 15.3997L21.8349 20.1975L21.9054 20.268L21.9761 20.1977Z"
              stroke="#1B365D"
              stroke-width="0.2"
            />
          </svg>
        </div>
      ) : (
        <></>
      )}
      <div className={`panelistInfo__name panelistInfo__name--${origin} ${c}`}>{panelist}</div>
      <div className={`panelistInfo__title panelistInfo__title--${origin}`}>{title}</div>
      <div>
        <div className={`panelistInfo__year panelistInfo__year--${origin}`}>
          <span className="panelistInfo__year__head"> {years ? 'Years' : 'Year'} at ISEF: </span>
          {years ? years : year}
        </div>
        <p>{copy}</p>
      </div>
    </div>
  );
};

export default PanelistInfo;
